// public/js/features/feedback/api.js
const BASE = 'api/v1/feedback';

async function jfetch(url, opts) {
  const res = await window.authenticatedFetch(url, opts);
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

export const listThreads = (board) => jfetch(`${BASE}/threads?board=${encodeURIComponent(board)}`).then(d => d.threads || []);
export const getThread = (id) => jfetch(`${BASE}/threads/${encodeURIComponent(id)}`);
export const createThread = (payload) => jfetch(`${BASE}/threads`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const patchThread = (id, patch) => jfetch(`${BASE}/threads/${encodeURIComponent(id)}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(patch) });
export const deleteThread = (id) => jfetch(`${BASE}/threads/${encodeURIComponent(id)}`, { method: 'DELETE' });
export const addComment = (id, payload) => jfetch(`${BASE}/threads/${encodeURIComponent(id)}/comments`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
export const voteThread = (id, on) => jfetch(`${BASE}/threads/${encodeURIComponent(id)}/vote`, { method: on ? 'POST' : 'DELETE' });

export async function uploadImage(payload) {
  const d = await jfetch(`${BASE}/uploads`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
  return d.attachment;
}

// Attachments are private (served through the Lambda with auth) — fetch as a
// blob and hand back an object URL for <img src>. <img> can't send the bearer
// token, so we can't point it straight at the API.
export async function attachmentObjectUrl(threadId, key) {
  const res = await window.authenticatedFetch(`${BASE}/threads/${encodeURIComponent(threadId)}/att?key=${encodeURIComponent(key)}`);
  if (!res.ok) throw new Error('attachment load failed');
  return URL.createObjectURL(await res.blob());
}
